export default "__VITE_ASSET__edd25404__"